export const ko = {
  // Header
  home: "홈",
  pricing: "가격",
  features: "기능",
  faq: "자주 묻는 질문",
  aiGenerator: "AI 이미지 생성기",
  login: "로그인",

  // Hero Section
  heroTitle: "Lunabrush AI",
  heroSubtitle: "몇 초 만에 놀라운 AI 생성 이미지 만들기",
  worldFirstFree: "세계 최초의 무제한 무료 AI 이미지 생성기",
  hundredPercentFree: "100% 무료",
  poweredByFlux: "Flux19sv 제공",
  noLoginRequired: "로그인 불필요",
  unlimitedGeneration: "무제한 생성",

  // AI Generator Section
  aiGeneratorTitle: "AI 이미지 생성기",
  freeTrial: "무료 체험",
  describeImage: "생성하고 싶은 이미지를 설명하세요...",
  generating: "생성 중...",
  generateImage: "이미지 생성",
  generatingPlease: "생성 중입니다. 잠시만 기다려주세요......",

  // Gallery Section
  inspiration: "영감 얻기",
  inspirationDesc: "Lunabrush AI가 생성한 놀라운 이미지들을 탐색하세요",
  viewMore: "더 보기",

  // Image Gallery
  futuristicCity: "미래 도시 야경, 네온 조명, 사이버펑크 스타일",
  forestCabin: "안개에 둘러싸인 숲속의 신비로운 오두막",
  spaceAstronaut: "우주의 우주비행사, 성운 배경",
  underwaterWorld: "수중 세계, 산호초, 열대어",
  samurai: "고대 일본 사무라이, 떨어지는 벚꽃",
  mountainLake: "산 호수, 일출, 얇은 안개",
  spaceStation: "공상과학 우주 정거장, 행성 배경",
  magicForest: "마법의 숲, 빛나는 버섯, 요정",

  // Features
  featuresTitle: "Lunabrush의 주요 기능",
  featuresDesc: "최고의 이미지 생성 경험을 제공하기 위해 AI 모델을 지속적으로 개선합니다",
  highQuality: "고품질 생성",
  highQualityDesc: "최첨단 AI 모델을 사용하여 놀라운 고품질 이미지 생성",
  fastResponse: "빠른 응답",
  fastResponseDesc: "몇 초 만에 AI 생성 이미지를 얻으세요, 기다림 없음",
  privacyProtection: "개인정보 보호",
  privacyProtectionDesc: "프롬프트와 생성된 이미지는 엄격하게 보호됩니다",
  multipleStyles: "다양한 스타일",
  multipleStylesDesc: "사실적인 것부터 애니메이션까지 다양한 아트 스타일 지원",
  globalAvailable: "전 세계 이용 가능",
  globalAvailableDesc: "글로벌 서버 배포로 빠른 액세스와 생성 보장",
  apiAccess: "API 액세스",
  apiAccessDesc: "엔터프라이즈급 API 액세스, 애플리케이션에 쉽게 통합",

  // Stats
  statsTitle: "수백만 명이 신뢰합니다",
  statsDesc: "글로벌 커뮤니티에 참여하고 AI 이미지 생성의 무한한 가능성을 탐색하세요",
  registeredUsers: "등록 사용자",
  dailyImages: "일일 생성 이미지",
  averageRating: "평균 평점",
  millionPlus: "300만+",
  dailyCount: "1,530",
  rating: "4.9",

  // Testimonials
  testimonialsTitle: "Lunabrush AI에 대한 사용자 평가",
  testimonialsDesc: "다른 사용자들이 Lunabrush AI를 사용하여 창작 워크플로우를 향상시키는 방법을 확인하세요",
  testimonial1Name: "리밍",
  testimonial1Role: "UI/UX 디자이너",
  testimonial1Content:
    "Lunabrush AI는 제 디자인 프로세스를 완전히 바꿔놓았습니다. 컨셉 이미지를 빠르게 생성할 수 있어 많은 시간을 절약할 수 있습니다. 이미지 품질이 놀랍습니다!",
  testimonial2Name: "왕샤오화",
  testimonial2Role: "콘텐츠 크리에이터",
  testimonial2Content:
    "콘텐츠 크리에이터로서 매일 많은 이미지 자료가 필요합니다. Lunabrush AI를 사용하면 독특한 이미지를 쉽게 생성할 수 있어 작업 효율성이 크게 향상됩니다.",
  testimonial3Name: "장웨이",
  testimonial3Role: "게임 개발자",
  testimonial3Content:
    "Lunabrush AI의 이미지 생성 능력은 매우 강력하며, 특히 게임 컨셉 아트 제작에 도움이 됩니다. 팀이 아이디어를 빠르게 반복하고 개발 프로세스를 가속화하는 데 도움이 됩니다.",

  // FAQ
  faqTitle: "자주 묻는 질문",
  faqDesc: "서비스에 대한 일반적인 질문에 대한 답변 찾기",
  faq1Question: "왜 Lunabrush AI를 사용해야 하나요?",
  faq1Answer:
    "Lunabrush AI는 최첨단 AI 이미지 생성 기술을 제공하여 사용자가 원클릭으로 아름다운 이미지를 만들 수 있습니다! 우리의 모델은 복잡한 프롬프트를 이해하고 고품질의 세밀한 이미지를 생성하도록 특별히 훈련되었습니다. 또한 다양한 창작 요구를 충족하기 위해 다양한 스타일 옵션을 제공합니다.",
  faq2Question: "구독을 업그레이드하거나 취소할 수 있나요?",
  faq2Answer:
    "물론입니다! 계정 설정에서 언제든지 구독 플랜을 업그레이드하거나 다운그레이드할 수 있습니다. 구독을 취소하기로 결정하면 계정 페이지에서 쉽게 할 수 있으며 추가 요금이 부과되지 않습니다.",
  faq3Question: "환불을 받을 수 있나요?",
  faq3Answer: "아니요, 환불 서비스는 제공하지 않습니다.",
  faq4Question: "내 프롬프트를 저장하나요?",
  faq4Answer:
    "네, 서비스 개선을 위해 프롬프트를 저장합니다. 하지만 사용자 개인정보를 매우 중요하게 생각하며, 저장된 모든 프롬프트는 익명화되어 개인정보와 연결되지 않습니다. 유료 사용자인 경우 개인정보 보호 모드를 활성화할 수 있으며, 이 경우 프롬프트가 저장되지 않습니다.",
  faq5Question: "Ultimate에 구독하면 더 높은 품질의 이미지를 얻을 수 있나요?",
  faq5Answer:
    "네! Ultimate 구독 사용자는 더 높은 해상도와 더 풍부한 세부 사항을 가진 이미지를 생성하는 고해상도(HD) 이미지 생성 기능에 액세스할 수 있습니다. 또한 Ultimate 사용자는 더 높은 품질의 이미지를 생성하도록 특별히 최적화된 전문 모델도 사용할 수 있습니다.",
  faq6Question: "구독하면 여전히 광고를 보게 되나요?",
  faq6Answer:
    "유료 플랜에 구독하면 광고를 보지 않게 됩니다. 유료 사용자에게 창작에 집중할 수 있도록 최고의 방해받지 않는 경험을 제공하고자 합니다.",
  faq7Question: "사용자 지원을 요청할 수 있나요?",
  faq7Answer: "네! 기술 지원 및 도움을 위해 support@lunabrush.ai로 이메일을 보내 문의할 수 있습니다.",
  faq8Question: "엔터프라이즈급 서비스란 무엇인가요?",
  faq8Answer:
    "특별한 솔루션이 필요한 경우, 전용 지원, 더 높은 사용량 할당량, API 액세스 등을 포함한 엔터프라이즈급 서비스를 제공합니다. 자세한 내용은 sales@lunabrush.ai로 문의하세요.",

  // Footer
  footerDesc: "Lunabrush AI는 FLUX-LLM 기술의 리더로 AI 이미지 생성에 특화",
  allRightsReserved: "Lunabrush AI. 모든 권리 보유",
  tools: "도구",
  support: "지원",
  imageGallery: "이미지 갤러리",
  termsOfService: "서비스 약관",
  privacyPolicy: "개인정보 처리방침",

  // Login Page
  welcomeTitle: "Lunabrush AI에 오신 것을 환영합니다",
  welcomeDesc: "로그인 방법을 선택하여 놀라운 AI 이미지 생성을 시작하세요",
  googleLogin: "Google로 로그인",
  githubLogin: "GitHub로 로그인",
  loggingIn: "로그인 중...",
  loginTerms: "로그인하면 당사의",
  and: "및",

  // Create Page
  createImage: "이미지 생성",
  createDesc: "Lunabrush AI로 놀라운 이미지 생성",
  basic: "기본",
  advanced: "고급",
  prompt: "프롬프트",
  promptPlaceholder: "생성하고 싶은 이미지를 설명하세요...",
  model: "모델",
  selectModel: "모델 선택",
  negativePrompt: "네거티브 프롬프트",
  negativePromptPlaceholder: "이미지에 나타나지 않았으면 하는 내용...",
  aspectRatio: "종횡비",
  selectAspectRatio: "종횡비 선택",
  promptStrength: "프롬프트 강도",
  highQualityGeneration: "고품질 생성 (시간이 더 걸림)",
  preview: "미리보기",
  imageWillAppear: "이미지가 여기에 표시됩니다",
  enterPrompt: "프롬프트를 입력하고 생성 버튼을 클릭하세요",
  download: "다운로드",
  share: "공유",
  bookmark: "북마크",

  // Gallery Page
  galleryTitle: "이미지 갤러리",
  galleryDesc: "Lunabrush AI가 생성한 놀라운 이미지들을 탐색하세요",
  searchPrompts: "프롬프트 검색...",
  sortBy: "정렬 기준",
  latest: "최신",
  popular: "인기",
  trending: "트렌딩",
  style: "스타일",
  allStyles: "모든 스타일",
  realistic: "사실적",
  anime: "애니메",
  digitalArt: "디지털 아트",
  fantasy: "판타지",
  loadMore: "더 보기",

  // Pricing
  choosePlan: "플랜 선택",
  pricingDesc: "Lunabrush AI 프리미엄으로 더 빠른 생성 속도와 고급 기능 선택",
  monthly: "월간",
  yearly: "연간",
  saveTwoMonths: "2개월 절약",
  advanced: "고급",
  personalUse: "개인 사용에 완벽",
  unlimitedGeneration: "무제한 이미지 생성",
  fastGeneration: "빠른 생성 (5장/분)",
  noAds: "광고 없음",
  noWatermark: "워터마크 없음",
  upgradeToAdvanced: "고급으로 업그레이드",
  ultimate: "얼티밋",
  mostPopular: "가장 인기",
  professionalCreators: "전문 크리에이터에게 완벽",
  ultraFastGeneration: "초고속 생성",
  hdResolution: "고급 HD 해상도",
  privateGeneration: "비공개 생성",
  advancedModels: "10개 이상의 고급 모델 지원",
  earlyAccess: "새로운 기능에 대한 조기 액세스",
  upgradeToUltimate: "얼티밋으로 업그레이드",
  enterprise: "엔터프라이즈",
  custom: "맞춤형",
  teamsAndEnterprises: "팀과 기업에 완벽",
  customSolutions: "맞춤형 솔루션",
  dedicatedSupport: "전용 지원",
  teamIntegration: "팀 도구 통합",
  highVolume: "대용량",
  contactUs: "문의하기",

  // Style Options
  style: "스타일",
  noStyle: "스타일 없음",
  digitalArt: "디지털 아트",
  cyberpunk: "사이버펑크",
  lineArt: "선화",
  photography: "사진",
  film: "필름",
  origami: "종이접기",
  model3d: "3D 모델",
  anime: "애니메",
  fantasyArt: "판타지 아트",
  lowPoly: "로우 폴리",
  cinematic: "영화적",
  enhanced: "향상된",
  comicBook: "만화책",
  isometric: "등축투영",
  clay: "점토",

  // Color Tone Options
  colorTone: "색조",
  noColor: "무채색",
  warmTones: "따뜻한 톤",
  coolTones: "차가운 톤",
  softColors: "부드러운 색상",
  vibrantColors: "선명한 색상",
  pastelColors: "파스텔 색상",
  blackAndWhite: "흑백",

  // Lighting Options
  lighting: "조명",
  noLighting: "조명 없음",
  dramatic: "드라마틱",
  dimLighting: "어두운 조명",
  studio: "스튜디오",
  lowLight: "저조도",
  goldenHour: "골든 아워",
  backlight: "역광",
  volumetricLight: "볼류메트릭 라이트",
  tyndallEffect: "틴들 효과",
  sunlight: "햇빛",
  rimLight: "림 라이트",

  // Composition Options
  composition: "구도",
  noComposition: "구도 없음",
  blurredBackground: "흐린 배경",
  closeUp: "클로즈업",
  wideAngle: "광각",
  shallowDepthOfField: "얕은 피사계 심도",
  bottomUpShot: "아래에서 위로 촬영",
  topDownShot: "위에서 아래로 촬영",
  macroPhotography: "매크로 사진",

  // 通用
  close: "닫기",
} as const
